import { useEffect, useState } from "react";

import { OrganizationsAdminService } from "../services/organizationsAdmin.service";

// A failed read hides the pesos switches, nothing else.
export function useCardCopTopUpsAccess(): boolean {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    OrganizationsAdminService.getCardCopTopUpsAccess().then(
      (value) => {
        if (!cancelled) setAllowed(value);
      },
      () => undefined,
    );
    return () => {
      cancelled = true;
    };
  }, []);

  return allowed;
}
